module.exports = __webpack_public_path__ + "img/phone.ecb7552b.svg";